<template>
  <div>
    <v-row class="notification-builder-field-wrapper">
      <v-text-field
        class="notification-builder-field"
        required
        filled
        placeholder="Title"
        label="Title"
        v-model="title"
        :error-messages="titleErrors"
        @blur="() => $v.title.$touch()"
      >
      </v-text-field>
    </v-row>

    <v-row class="notification-builder-field-wrapper">
      <v-textarea
        placeholder="Message"
        label="Message"
        class="notification-builder-field"
        filled
        required
        no-resize
        rows="4"
        v-model="message"
        :error-messages="messageErrors"
        @blur="() => $v.message.$touch()"
      />
    </v-row>

    <!-- <v-row class="ma-2 px-3 font-size-large font-weight-medium">
      Small icon (Android only)
    </v-row>

    <v-row class="ma-2 px-3">
      <v-col class="pa-0">
        <v-text-field
          class="notification-builder-message-field"
          v-model="androidSmallIcon"
        >
        </v-text-field>
      </v-col>
    </v-row>

    <v-row class="ma-2 px-3 font-size-large font-weight-medium">
      Icon (Android only)
    </v-row>

    <v-row class="ma-2 px-3">
      <v-col class="pa-0">
        <v-text-field
          class="notification-builder-message-field"
          v-model="androidIcon"
        >
        </v-text-field>
      </v-col>
    </v-row> -->

    <v-row class="notification-builder-field-wrapper d-flex">
      <v-text-field
        :disabled="false"
        placeholder="Image"
        label="Image"
        class="notification-builder-field"
        filled
        v-model="image"
        id="notification-builder-image-text-field"
        @blur="() => $v.image.$touch()"
        :error-messages="imageErrors"
      />
    </v-row>

    <!-- <v-row class="ma-2 px-3 font-size-large font-weight-medium">
      Clickthough behaviour
    </v-row>

    <v-row class="ma-2 px-3">
        <v-radio-group v-model="clickthroughBehaviour" row>
          <v-radio
            label="QR Code"
            key="clickthrough1"
            :value="clickthroughBehaviours.qrCode"
          ></v-radio>
          <v-radio
            label="Deep link"
            key="clickthrough2"
            :value="clickthroughBehaviours.deepLink"
          ></v-radio>
        </v-radio-group>
    </v-row> -->

    <v-row
      class="notification-builder-field-wrapper d-flex"
      v-if="clickthroughBehaviour === clickthroughBehaviours.deepLink"
    >
      <v-text-field
        :disabled="false"
        class="notification-builder-field"
        filled
        placeholder="Deep Link"
        label="Deep Link"
        v-model.trim="deepLink"
      />
    </v-row>

    <!-- <v-row
      class="ma-2 px-3"
      v-if="clickthroughBehaviour === clickthroughBehaviours.qrCode"
    >
      <v-text-field class="notification-builder-message-field" v-model="qrCode">
      </v-text-field>
    </v-row> -->

    <!-- <v-row class="ma-2 px-3 font-size-large font-weight-medium">
      Button 1 - text
    </v-row>

    <v-row class="ma-2 px-3">
      <v-col class="pa-0">
        <v-text-field
          class="notification-builder-message-field"
          v-model="button0Text"
        >
        </v-text-field>
      </v-col>
    </v-row>

    <v-row class="ma-2 px-3 font-size-large font-weight-medium">
      Button 1 - deep link
    </v-row>

    <v-row class="ma-2 px-3">
      <v-col class="pa-0">
        <v-text-field
          class="notification-builder-message-field"
          v-model="button0DeepLink"
        >
        </v-text-field>
      </v-col>
    </v-row>

    <v-row class="ma-2 px-3 font-size-large font-weight-medium">
      Button 2 - text
    </v-row>

    <v-row class="ma-2 px-3">
      <v-col class="pa-0">
        <v-text-field
          class="notification-builder-message-field"
          v-model="button1Text"
        >
        </v-text-field>
      </v-col>
    </v-row>

    <v-row class="ma-2 px-3 font-size-large font-weight-medium">
      Button 2 - deep link
    </v-row>

    <v-row class="ma-2 px-3">
      <v-col class="pa-0">
        <v-text-field
          class="notification-builder-message-field"
          v-model="button1DeepLink"
        >
        </v-text-field>
      </v-col>
    </v-row> -->

    <v-row class="notification-builder-field-wrapper">
      <!-- <div class="notification-builder-field" style="line-height: 28px">
        Segment
      </div>

      <div
        class="notification-builder-field text--secondary mt-0"
        style="line-height: 28px"
      > -->
      <v-select
        filled
        placeholder="Segment"
        label="Segment"
        text="text"
        value="value"
        height="28px"
        style="max: 100%"
        id="notification-builder-segment-v-select"
        v-model="profile"
        :items="allProfiles"
        @blur="
          () => {
            $v.profile.$touch();
          }
        "
      />
      <!-- </div> -->
    </v-row>

    <v-row
      class="notification-builder-field-wrapper notification-builder-trigger-wrapper"
    >
      <!-- <v-radio-group v-model="actionType" :error-messages="actionTypeErrors">
      <template v-slot:label>
        <div>Send this notification:</div>
      </template>
        <v-radio
          v-for="action in actionTypes"
          :key="action.text"
          :label="action.text"
          :value="action.value"
        ></v-radio>
      </v-radio-group> -->

      <v-select
        label="Send this notification"
        v-model="actionType"
        :items="actionTypes"
        filled
        :error-messages="actionTypeErrors"
      >
      </v-select>
      <!-- <v-radio-group v-model="actionType" :error-messages="actionTypeErrors">
        <template v-slot:label>
          <div>Send this notification:</div>
        </template>
        <v-radio
          v-for="action in actionTypes"
          :key="action.text"
          :label="action.text"
          :value="action.value"
        ></v-radio>
      </v-radio-group> -->
    </v-row>
    <v-row
      class="notification-builder-field-wrapper notification-builder-trigger-wrapper"
    >
      <div
        v-if="actionType"
        class="notification-builder-field text--secondary mt-0"
        style="line-height: 28px"
      >
        <calendar
          v-if="actionType === 'AbsoluteCalendarNotification'"
          ref="action"
          class="fade-in"
          v-model="action"
        />
        <woos
          v-if="actionType === 'woos_action'"
          ref="action"
          class="fade-in"
          v-model="action"
          :error-messages="actionErrors"
          @blur="() => $v.action.$touch()"
        />
        <journey
          v-if="actionType === 'ArrivalNotification_or_DepartureNotification'"
          ref="action"
          class="fade-in"
          :profile-id="profile ? profile.id : null"
          v-model="action"
        />

        <instant
          v-if="actionType === 'InstantNotification'"
          ref="action"
          v-model="action"
        />
      </div>
    </v-row>

    <!-- Expires -->
    <!-- <v-row
      class="notification-builder-field-wrapper notification-builder-expiry-wrapper"
    >
      <div class="notification-builder-field" style="line-height: 28px">
        Expiry
      </div>

      <div
        class="notification-builder-field text--secondary mt-2"
        style="line-height: 28px"
      >
        <cvc-time-input
          class="mt-2 ml-1"
          v-model="expiresTime"
          min-time="00:00"
          max-time="24:00"
        />
        <cvc-date-input
          class="mt-2"
          v-model="expiresDate"
          :allowed-dates="allowedDates"
          :width="200"
          :clearable="false"
          :error-messages="expiresErrors"
        />
      </div>
    </v-row> -->

    <v-row class="notification-builder-actions-wrapper">
      <v-col class="pa-0 text-align-right">
        <send-notification-modal
          :disabled="$v.$invalid"
          :brand="brand"
          :form-data="formData"
          :reset-form-data="resetFormData"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { validationMixin } from 'vuelidate';
  import { required, url, maxLength } from 'vuelidate/lib/validators';
  import Woos from '@/components/Notifications/ActionTypes/Woos';
  import Calendar from '@/components/Notifications/ActionTypes/Calendar';
  import Journey from '@/components/Notifications/ActionTypes/Journey';
  import Instant from '@/components/Notifications/ActionTypes/Instant';

  import { addDays, parseISO, format, endOfToday } from 'date-fns';
  import SendNotificationModal from '@/components/Notifications/SendNotificationModal';

  const todayEnd = endOfToday();

  // A little enum of clickthough behaviours
  const clickthroughBehaviours = Object.freeze({
    qrCode: 'qrCode',
    deepLink: 'deepLink',
  });

  export default {
    name: 'NotificationBuilderForm',
    components: {
      SendNotificationModal,
      Calendar,
      Woos,
      Journey,
      Instant,
    },
    mixins: [validationMixin],
    validations: {
      title: { maxLength: maxLength(100) },
      message: { required, maxLength: maxLength(200) },
      profile: {},
      image: {
        imageValidation: (val) =>
          val === ''
            ? true
            : val.slice(-3) === 'png' || val.slice(-3) === 'jpg',
        url,
        https: (val) => val === '' || val.startsWith('https://'),
      },
      actionType: { required },
      action: { required },
      expiresDate: { required },
      expiresTime: { required },
    },
    data() {
      return {
        title: process.env.NODE_ENV === 'development' ? 'Test message' : '',
        message:
          process.env.NODE_ENV === 'development' ? 'No action needed' : '',
        image: '',
        deepLink: '',
        qrCode: '',
        button0Text: '',
        button0DeepLink: '',
        button1Text: '',
        button1DeepLink: '',
        clickthroughBehaviour: clickthroughBehaviours.deepLink,
        clickthroughBehaviours,
        expiresTime: '00:00',
        expiresDate: format(addDays(new Date(), 700), 'yyyy-MM-dd'),
        profile: null,
        actionType: 'AbsoluteCalendarNotification',
        actionTypes: [
          // { text: "...", value: null },

          {
            text: 'on a given time and date.',
            value: 'AbsoluteCalendarNotification',
          },
          {
            text: 'immediately',
            value: 'InstantNotification',
          },
          // TODO this will be reimplemented later
          // { text: 'during a journey.', value: 'ArrivalNotification_or_DepartureNotification', },
          // TODO this will be reimplemented later
          // { text: "during a window of opportunity.", value: "woos_action" },
        ],
        action: {},
      };
    },
    props: {
      brand: {
        type: Object,
        required: true,
      },
    },
    computed: {
      titleErrors() {
        return [
          ...(!this.$v.title.maxLength
            ? ['Title must be 100 characters or less']
            : []),
        ];
      },
      messageErrors() {
        return [
          ...(!this.$v.message.maxLength
            ? ['Message must be 200 characters or less']
            : []),
          ...(this.$v.message.$dirty
            ? [...(!this.$v.message.required ? ['Message is required'] : [])]
            : []),
        ];
      },
      expiresErrors() {
        return !this.$v.expiresDate.$dirty || !this.$v.expiresTime.$dirty
          ? []
          : [
              ...(!this.$v.expiresDate.required || !this.$v.expiresTime.required
                ? ['Expiry is required']
                : []),
            ];
      },
      displayActionTypes() {
        return process.env.VUE_APP_ALL_ACTION_TYPES === 'true';
      },
      actionTypeErrors() {
        return !this.$v.actionType.$dirty
          ? []
          : [...(!this.$v.actionType.required ? ['Trigger is required'] : [])];
      },
      imageErrors() {
        return !this.$v.image.$dirty
          ? []
          : [
              ...(!this.$v.image.imageValidation
                ? ['Must be PNG or JPG (i.e. end in .png or .jpg)']
                : []),
              ...(!this.$v.image.url
                ? ['Must be publicly available URL starting with https://']
                : []),
              ...(!this.$v.image.https
                ? ['Must be publicly available URL starting with https://']
                : []),
            ];
      },
      actionErrors() {
        // This is a fancy errors thing. Because action can be multiple schemas,
        // we validate manually
        if (this.actionType === 'woos_action') {
          return !this.$v.action.$dirty
            ? {}
            : {
                // Check that offset is a number
                ...(typeof this.action.offset !== 'number' && {
                  offset_errors: 'Offset must be a number',
                }),
                // Check that start_or_end has a valid value
                ...(!(
                  this.action.start_or_end === 'start' ||
                  this.action.start_or_end === 'end'
                ) && {
                  start_or_end_errors: 'Start or end of WoO must be set',
                }),
                // Check that display_date has a valid value
                ...(this.action.display_date === '' && {
                  display_date_errors: 'Display date must be set',
                }),
                // Check that index or ranges is specified
                ...(this.action.index === undefined &&
                  this.action.ranges === undefined && {
                    index_or_range_errors:
                      'Position (e.g. first, last, etc.) of WoO must be set',
                  }),
              };
        }
        return {};
      },
      allProfiles() {
        return [{ text: 'All users', value: null }].concat(
          this.$store.getters.nonDeletedOrExpiredProfiles
            .filter((p) => p.released)
            .map((p) => ({
              text: p.name,
              value: { id: p.id, version: p.version },
            }))
        );
      },
      payload() {
        // OK, so this is kind of straight up JS functional magic. See
        // https://2ality.com/2017/04/conditional-literal-entries.html for how it
        // works.
        return {
          title: this.title,
          message: this.message,
          // Optional fields
          ...(this.deepLink && { deep_link: this.deepLink }),
          ...(this.image && { image: this.image }),
          ...(this.qrCode && { promotion: { qr_code: this.qrCode } }),
          ...(this.button0Text && {
            buttons: [
              {
                text: this.button0Text,
                ...(this.button0DeepLink && {
                  deep_link: this.button0DeepLink,
                }),
              },
              ...(this.button1Text && [
                {
                  text: this.button1Text,
                  ...(this.button1DeepLink && {
                    deep_link: this.button1DeepLink,
                  }),
                },
              ]),
            ],
          }),
        };
      },
      formData() {
        let actionType = null;
        let actionArgs = {};
        if (
          this.actionType === 'AbsoluteCalendarNotification' ||
          this.actionType == 'InstantNotification'
        ) {
          actionType = this.actionType;
          actionArgs = this.action;
        }

        if (
          this.actionType === 'ArrivalNotification_or_DepartureNotification'
        ) {
          // OK, time to determine if this is an arrival or departure notification
          if (this.action.direction === 'inbound') {
            actionType = 'ArrivalNotification';
          } else if (this.action.direction === 'outbound') {
            actionType = 'DepartureNotification';
          }
          actionArgs = { set_id: this.action.set_id };
        }

        return {
          metadata: {
            target: {
              ...(this.profile && {
                profile_name: this.profile.id,
                min_profile_version: this.profile.version,
              }),
              ...(this.brand.package_id && {package_id: this.brand.package_id}),
              ...(!this.brand.package_id && {brand: this.brand.application}),
            },
            ...(this.expiresDate &&
              this.expiresTime && {
                expires: parseISO(
                  `${this.expiresDate} ${this.expiresTime}:00`
                ).toISOString(),
              }),
          },
          action: {
            type: actionType,
            args: actionArgs,
            payload: this.payload,
          },
        };
      },
    },
    watch: {
      clickthroughBehaviour() {
        // Reset qrCode and deepLink to make sure we never send both in the payload
        this.qrCode = '';
        this.deepLink = '';
      },
      formData: {
        handler(newVal) {
          this.$emit('input', newVal);
        },
        immediate: true,
      },
      value(newVal) {
        // This v-model doesn't work right yet, because it blatently ignores what
        // comes in and just resets the form data

        if (newVal === {}) {
          this.$nextTick(() => {
            this.resetFormData();
          });
        }
      },
    },
    methods: {
      allowedDates(val) {
        const expiryDate = parseISO(val);
        return expiryDate > todayEnd;
      },
      resetFormData() {
        this.$v.$reset();
        this.title = '';
        this.message = '';
        this.androidIcon = '';
        this.androidSmallIcon = '';
        this.image = '';
        this.deepLink = '';
        this.qrCode = '';
        this.clickthroughBehaviour = clickthroughBehaviours.deepLink;
        this.button0Text = '';
        this.button0DeepLink = '';
        this.button1Text = '';
        this.button1DeepLink = '';
        this.profile = null;
        this.actionType =
          process.env.VUE_APP_ALL_ACTION_TYPES === 'true'
            ? null
            : 'AbsoluteCalendarNotification';
        if (process.env.VUE_APP_ALL_ACTION_TYPES === 'true') {
          this.action = {};
        }

        this.$v.title.$reset();
        this.$v.message.$reset();
        this.$v.profile.$reset();
      },
    },
  };
</script>

<style lang="scss">
  .notification-builder-wrapper {
    // display: flex !important;
  }
  .notification-builder-field-wrapper {
    // background-color: white;
    // display: block;
    // overflow: hidden;
    // margin: 0 0 14px 0;
  }
  .notification-builder-trigger-wrapper {
    // height: 179px;
  }
  .notification-builder-expiry-wrapper {
    // height: 120px;
  }
  .notification-builder-field {
    // margin: 7px 18px 0 18px;
  }
  .notification-builder-segment-field {
    // .v-input__append-inner {
    //   margin-top: 0;
    // }
    // .v-select__selection {
    //   margin-top: 0;
    // }
  }
  .notification-builder-actions-wrapper {
    // margin: 0 0 12px 0;
  }
</style>
